export const HANDLE_NEXT = "Next";
export const HANDLE_TRUE = "True";
export const HANDLE_FALSE = "False";
export const HANDLE_SUCCESS = "Success";
export const HANDLE_FAILED = "Failed";
export const HANDLE_CANCELLED = "Cancelled";
export const HANDLE_IN_PROGRESS = "InProgress";
export const HANDLE_SUCCEEDED = "Succeeded";
export const HANDLE_ERROR = "Error";
export const HANDLE_NOT_STARTED = "NotStarted";
export const HANDLE_ARRIVED = "Arrived";
export const HANDLE_NO_WAY = "NoWay";
export const HANDLE_ON_START = "OnStart";
export const HANDLE_ON_END = "OnEnd";
export const HANDLE_ON_EVENT = "OnEvent";

export const NEXT_ONLY = [HANDLE_NEXT] as const;
